import React, { useEffect } from 'react';
import LogoGrowth from '../Logo/Logogrowth';
import './style.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import LogoDark from '../Logo/LogoDark';
import Steps from '../Steps/Steps';
import useMixpanel from '../../hooks/useMixpanel';

export default function Header({ step, steps }) {
    const history = useHistory();

    const {trackEvent} = useMixpanel();

    return (
        <div className="header">
            <div className="header-top">
                {step.id === 'booster-prediction' && (
                    <div
                        className="back"
                        onClick={() => {
                            trackEvent('onboarding_booster_prediction', {
                                booster_choosen: 'FALSE',
                            })
                            history.push('/thankyou');
                        }}>
                        <svg
                            style={{ width: '30rem', height: '30rem' }}
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9 9L21 21"
                                stroke="#A7A8AA"
                                stroke-width="2"
                                stroke-linecap="round"
                            />
                            <path
                                d="M21 9L9 21"
                                stroke="#A7A8AA"
                                stroke-width="2"
                                stroke-linecap="round"
                            />
                        </svg>
                    </div>
                )}
                {step.id === 'booster' && (
                    <div
                        className="back"
                        style={{
                            left: 'auto',
                            right: '0',
                            fontSize: '14rem',
                            color: '#A7A8AA',
                            fontWeight: '600',
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            trackEvent('onboarding_booster', {
                                booster_choosen: 'FALSE',
                            })
                            history.push('/booster-prediction');
                        }}>
                        Skip
                    </div>
                )}
                {['', 'reviews', 'hello', 'signup', 'name', 'plan', 'final-offer','summary-proof','replace','final-plan', 'features', 'trial'].includes(step.id) && (
                    <LogoDark style={{ width: '78rem', height: '22rem' }} />
                )}
                {steps.indexOf(step) > steps.findIndex((step) => step.id === '') &&
                    steps.indexOf(step) < steps.findIndex((step) => step.id === 'reviews') && (
                        <Steps steps={steps} stepIndex={steps.indexOf(step)} />
                    )}

                {steps.indexOf(step) > steps.findIndex((step) => step.id === 'welcome') && (
                    <LogoGrowth style={{ width: '151rem', height: '32rem' }} />
                )}
            </div>
        </div>
    );
}
